import { type Client, graphql, prefetch } from "@opensea/graphql"
import { CollectionItemsMakeOfferButtonFragment } from "@/components/items/collection/CollectionItemsActionBar/CollectionItemsMakeOfferButton.fragment"

export const CollectionOffersActionBarQuery = graphql(
  `
    query CollectionOffersActionBarQuery($collectionSlug: String!) {
      collectionBySlug(slug: $collectionSlug) {
        __typename
        ... on Collection {
          id
          ...CollectionItemsMakeOfferButton
        }
      }
    }
  `,
  [CollectionItemsMakeOfferButtonFragment],
)

export const prefetchCollectionOffersActionBarQuery = (
  collectionSlug: string,
  client: Client,
) => {
  prefetch(client, CollectionOffersActionBarQuery, {
    collectionSlug,
  })
}
